import {
  Component,
  OnInit,
  Input,
  ViewChild,
  AfterViewInit,
  ElementRef,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import {
  ConfiguracionVehicularSigoEnum,
  TipoEngancheModularSigoEnum,
} from "../../models/vehiculo-models";

@Component({
  selector: "[app-sigo-tracto-dolly-modular-sk]",
  templateUrl: "./sigo-tracto-dolly-modular-snkinpin.component.html",
  styleUrls: ["./sigo-tracto-dolly-modular-snkinpin.component.scss"],
})
export class SigoTractoDollyModularSinKinpinComponent
  implements OnInit, OnChanges, AfterViewInit
{
  @Input("ejesPrimerVehiculo") ejesPrimerVehiculo: number = 0;
  @Input("ejesSegundoVehiculo") ejesSegundoVehiculo: number = 0;
  @Input("ejesTercerVehiculo") ejesTercerVehiculo: number = 0;
  @Input("mostrarDistancias") mostrarDistancias: boolean = true;

  @ViewChild("seccionUltimoVehiculo", {
    static: false,
  })
  seccionUltimoVehiculo: ElementRef;
  @ViewChild("seccionUltimaDistancia", {
    static: false,
  })
  seccionUltimaDistancia: ElementRef;

  debeMostrarDistancias: boolean = true;
  configVehicularEnum = ConfiguracionVehicularSigoEnum;
  tipoEngancheEnum = TipoEngancheModularSigoEnum;

  constructor() {}

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes.ejesPrimerVehiculo &&
      changes.ejesPrimerVehiculo.firstChange &&
      changes.ejesSegundoVehiculo &&
      changes.ejesSegundoVehiculo.firstChange &&
      changes.ejesTercerVehiculo &&
      changes.ejesTercerVehiculo.firstChange &&
      changes.tipoEngancheModular &&
      changes.tipoEngancheModular.firstChange &&
      changes.mostrarDistancias &&
      changes.mostrarDistancias.firstChange
    ) {
      return false;
    }

    this.establecerSiDebeMostrarDistancias();

    this.graficarDistanciasTercerVehiculo();
  }

  ngOnInit(): void {
    this.debeMostrarDistancias = this.mostrarDistancias ? true : false;

    this.establecerSiDebeMostrarDistancias();
  }

  private establecerSiDebeMostrarDistancias = () => {
    if (this.mostrarDistancias) {
      this.debeMostrarDistancias = this.ejesPrimerVehiculo > 0;
    } else {
      this.debeMostrarDistancias = false;
    }
  };

  ngAfterViewInit() {
    this.graficarDistanciasTercerVehiculo();
  }

  obtenerListaEjesPrimerVehiculo = () => {
    return this.crearListaSegunCantidadItems(this.ejesPrimerVehiculo);
  };

  obtenerListaEjesSegundoVehiculo = () => {
    return this.crearListaSegunCantidadItems(this.ejesSegundoVehiculo);
  };

  obtenerListaEjesTercerVehiculo = () => {
    return this.crearListaSegunCantidadItems(this.ejesTercerVehiculo);
  };

  private crearListaSegunCantidadItems = (cantidad) => {
    let lista = [];

    for (let i = 0; i < cantidad; i++) {
      lista.push({ id: i + 1 });
    }

    return lista;
  };

  private graficarDistanciasTercerVehiculo = () => {
    const ejesEstandar = 30;
    const ejesMaximos = 9 * ejesEstandar;

    let ejesActuales = ejesEstandar * this.ejesTercerVehiculo;

    this.graficarDistancias(ejesMaximos, ejesActuales);
  };

  private graficarDistancias = (ejesMax, ejesActuales) => {
    setTimeout(() => {
      if (ejesActuales < ejesMax) {
        let ultimaDistancia =
          this.seccionUltimoVehiculo.nativeElement.offsetWidth -
          ejesActuales / 2;
        this.seccionUltimaDistancia.nativeElement.style.width =
          ultimaDistancia + "px";
      } else {
        this.seccionUltimaDistancia.nativeElement.style.width =
          ejesActuales / 2 + "px";
      }
    }, 100);
  };
}
